<template>
  <div>
    <h2 class="subtitle">{{ store.storeInfo.name }}</h2>

    <div class="columns">
      <div class="column">
        <b-field :label="$t('billing.POSvalue')" label-position="on-border">
          <money
            :value="POSvalue"
            v-bind="money"
            class="input is-expanded"
            disabled
          ></money>
        </b-field>
      </div>

      <div class="column">
        <b-field :label="$t('billing.POSbeginDate')" label-position="on-border">
          <b-input
            :placeholder="$t('billing.POSbeginDate')"
            :value="getPOSBeginDateFormattedValue"
            disabled
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field :label="$t('billing.POSendDate')" label-position="on-border">
          <b-input
            :placeholder="$t('billing.POSendDate')"
            icon="calendar-day"
            :value="getPOSEndDateFormattedValue"
            disabled
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="Mensalidade TEF" label-position="on-border">
          <money
            :value="tefValue"
            v-bind="money"
            class="input is-expanded"
            disabled
          ></money>
        </b-field>
      </div>

      <div class="column">
        <b-field label="Início cobrança TEF" label-position="on-border">
          <b-input
            placeholder="Início cobrança TEF"
            icon="calendar-day"
            :value="getTefBeginDateFormattedValue"
            disabled
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field label="Fim cobrança TEF" label-position="on-border">
          <b-input
            placeholder="Fim cobrança TEF"
            icon="calendar-day"
            :value="getTefEndDateFormattedValue"
            disabled
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field :label="$t('billing.systemValue')" label-position="on-border">
          <money
            :value="systemValue"
            v-bind="money"
            class="input is-expanded"
            disabled
          ></money>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('billing.systemBeginDate')"
          label-position="on-border"
        >
          <b-input
            :placeholder="$t('billing.systemBeginDate')"
            :value="getSystemBeginDateFormattedValue"
            disabled
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('billing.systemEndDate')"
          label-position="on-border"
        >
          <b-input
            :placeholder="$t('billing.systemEndDate')"
            icon="calendar-day"
            :value="getSystemEndDateFormattedValue"
            disabled
          ></b-input>
        </b-field>
      </div>
    </div>

    <hr />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Money } from "v-money";

export default {
  props: ["store"],

  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2
      }
    };
  },

  components: {
    Money
  },

  computed: {
    ...mapGetters(["payments"]),

    POSvalue() {
      return this.store.storeInfo.POSvalue / 100;
    },

    getPOSBeginDateFormattedValue() {
      return this.store.storeInfo.POSbeginDate
        ? this.moment.utc(this.store.storeInfo.POSbeginDate).format("DD/MM/YY")
        : "-";
    },

    getPOSEndDateFormattedValue() {
      return this.store.storeInfo.POSendDate
        ? this.moment.utc(this.store.storeInfo.POSendDate).format("DD/MM/YY")
        : "-";
    },

    systemValue() {
      return this.store.storeInfo.systemValue / 100;
    },

    tefValue() {
      return this.store.storeInfo.tefValue
        ? this.store.storeInfo.tefValue / 100
        : 0;
    },

    getSystemBeginDateFormattedValue() {
      return this.store.storeInfo.systemBeginDate
        ? this.moment
            .utc(this.store.storeInfo.systemBeginDate)
            .format("DD/MM/YY")
        : "-";
    },

    getSystemEndDateFormattedValue() {
      return this.store.storeInfo.systemEndDate
        ? this.moment.utc(this.store.storeInfo.systemEndDate).format("DD/MM/YY")
        : "-";
    },

    getTefBeginDateFormattedValue() {
      return this.store.storeInfo.tefBeginDate
        ? this.moment.utc(this.store.storeInfo.tefBeginDate).format("DD/MM/YY")
        : "-";
    },

    getTefEndDateFormattedValue() {
      return this.store.storeInfo.tefEndDate
        ? this.moment.utc(this.store.storeInfo.tefEndDate).format("DD/MM/YY")
        : "-";
    }
  },

  mounted() {
    this.money.prefix = `${this.payments.currencySymbol} `;
  }
};
</script>
